/* eslint-disable no-unused-vars */
export const bodyScroll = (scroll = true) => {
  const body = document.body;

  function preventMotion(event) {
    // window.scrollTo(0, 0);
    event.preventDefault();
    event.stopPropagation();
  }

  function handleTouchMove(e) {
    e.preventDefault();
  }

  if (!scroll) {
    // add listener to disable scroll
    body.classList.add('is-blocked');
    document.addEventListener('touchmove', preventMotion, false);
    return;
  }
  // Remove listener to re-enable scroll
  window.removeEventListener('touchmove', preventMotion, false);
  body.classList.remove('is-blocked');
};



// WEBPACK FOOTER //
// ./scripts/util/helpers.js